// extracted by mini-css-extract-plugin
export default {"header":"HeaderLight_header__kYHkE","header_gray":"HeaderLight_header_gray__DmwN4","header_logo":"HeaderLight_header_logo__cf8oT"};